class DeferredSection extends HTMLElement {
  constructor() {
    super();
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (entries[0].isIntersecting) {
          this.loadContent();
          observer.unobserve(this);
        }
      },
      { rootMargin: '400px' }
    );
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  loadContent() {
    const template = this.querySelector('template');
    if (template) {
      this.appendChild(template.content.cloneNode(true));
      template.remove();
      // If there are scripts inside the template, they won't execute when cloned.
      // We must manually recreate them.
      const scripts = this.querySelectorAll('script');
      scripts.forEach(script => {
        if (script.src && document.querySelector(`script[src="${script.src}"]:not([type="text/lazyload"])`)) {
          script.remove();
          return;
        }
        const newScript = document.createElement('script');
        Array.from(script.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
        newScript.appendChild(document.createTextNode(script.innerHTML));
        script.parentNode.replaceChild(newScript, script);
      });
    }
  }
}

customElements.define('deferred-section', DeferredSection);
